import React from 'react';
import './LimitFilter.css';

import { LimitOptions } from './constants';

import LimitIcon from '../../assets/Icons/LimitIcon.svg?react';
import Suggestions, { Suggestion } from '../Suggestions/Suggestions';
import Flex from '../Flex/Flex';
import Text from '../Text/Text';
import CaretDownIcon from '../../assets/Icons/CaretDownIcon.svg?react';
import useOutsideClick from '../../hooks/useOutsideClick';
import { useTranslation } from 'react-i18next';

type Props = {
  value: number;
  onChange: (value: number) => void;
};

const LimitFilter = React.memo(({ onChange, value }: Props) => {
  const filterRef = React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const { t } = useTranslation('translation');

  const [needToShowSuggests, setNeedToShowSuggests] = React.useState(false);

  const handleOutsideClick = React.useCallback(() => {
    setNeedToShowSuggests(false);
  }, []);

  useOutsideClick(filterRef, handleOutsideClick);

  const handlePickerClick = React.useCallback(() => {
    setNeedToShowSuggests((x) => !x);
  }, []);

  const handleSelectLimit = React.useCallback(
    (suggestion: Suggestion) => {
      onChange(suggestion.id);
      setNeedToShowSuggests(false);
    },
    [onChange],
  );

  return (
    <div className="LimitFilter" ref={filterRef}>
      <Flex align="center" className="Filter__labelContent">
        <i className="Filter__icon">
          <LimitIcon />
        </i>
        <Text size={2} type="secondary">
          {t('limits')}
        </Text>
      </Flex>
      <Flex
        className="LimitFilter__limit-picker"
        justify="space-between"
        align="center"
        onClick={handlePickerClick}
      >
        <Text size={1} bold>
          {LimitOptions.find((x) => x.id === value)?.label}
        </Text>
        <i className="LimitFilter__picker-icon">
          <CaretDownIcon />
        </i>
      </Flex>
      {needToShowSuggests && <Suggestions suggestions={LimitOptions} onClick={handleSelectLimit} />}
    </div>
  );
});

export default LimitFilter;
